export default {
	name: 'Membership.Checkins',
	path: 'membership/checkins',
	meta: {
		auth: true
	}
}